import React, { useState, useEffect } from 'react';
import { BACKEND_URL } from '../config/api';

export default function TokenSelector({ selectedToken, onTokenChange, onFullTokenChange, label = "Select Token" }) {
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadApprovedTokens();
  }, []);

  const loadApprovedTokens = async () => {
    try {
      setLoading(true);
      setError('');

      // Fetch only approved tokens
      const response = await fetch(`${BACKEND_URL}/api/tokens/list?status=approved`);
      const data = await response.json();

      if (data.tokens && data.tokens.length > 0) {
        setTokens(data.tokens);

        // Auto-select first token if none selected
        if (!selectedToken && data.tokens.length > 0) {
          onTokenChange(data.tokens[0].symbol);
          if (onFullTokenChange) onFullTokenChange(data.tokens[0]);
        }
      } else {
        setError('No approved tokens available');
      }
    } catch (err) {
      console.error('Error loading tokens:', err);
      setError('Failed to load tokens');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ marginBottom: '16px' }}>
        <label style={{ display: 'block', marginBottom: '8px', color: '#A78BFA', fontWeight: '600' }}>
          {label}
        </label>
        <div style={{
          padding: '12px',
          backgroundColor: '#2a2a2a',
          border: '1px solid #3a3a3a',
          borderRadius: '8px',
          color: '#9ca3af',
          textAlign: 'center'
        }}>
          Loading tokens...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ marginBottom: '16px' }}>
        <label style={{ display: 'block', marginBottom: '8px', color: '#A78BFA', fontWeight: '600' }}>
          {label}
        </label>
        <div style={{
          padding: '12px',
          backgroundColor: '#7f1d1d',
          border: '1px solid #ef4444',
          borderRadius: '8px',
          color: '#fff',
          textAlign: 'center'
        }}>
          ⚠️ {error}
        </div>
      </div>
    );
  }

  return (
    <div style={{ marginBottom: '16px' }}>
      <label style={{ display: 'block', marginBottom: '8px', color: '#A78BFA', fontWeight: '600' }}>
        {label}
      </label>
      <select
        value={selectedToken}
        onChange={(e) => {
          const sym = e.target.value;
          onTokenChange(sym);
          if (onFullTokenChange) {
            const full = tokens.find(t => t.symbol === sym) || null;
            onFullTokenChange(full);
          }
        }}
        style={{
          width: '100%',
          padding: '12px',
          backgroundColor: '#2a2a2a',
          border: '1px solid #3a3a3a',
          borderRadius: '8px',
          color: '#fff',
          fontSize: '1rem',
          cursor: 'pointer',
          outline: 'none'
        }}
      >
        <option value="">-- Select Token --</option>
        {tokens.map(token => (
          <option key={token.symbol} value={token.symbol}>
            ${token.symbol} - {token.name}
          </option>
        ))}
      </select>

      {/* Token Details */}
      {selectedToken && tokens.find(t => t.symbol === selectedToken) && (
        <div style={{
          marginTop: '12px',
          padding: '12px',
          backgroundColor: '#2a2a2a',
          border: '1px solid #3a3a3a',
          borderRadius: '8px',
          fontSize: '0.875rem'
        }}>
          <div style={{ color: '#9ca3af', marginBottom: '8px' }}>
            <strong style={{ color: '#A78BFA' }}>Token Details:</strong>
          </div>
          {(() => {
            const token = tokens.find(t => t.symbol === selectedToken);
            return (
              <div style={{ color: '#d1d5db', lineHeight: '1.6' }}>
                <div>
                  <strong>Name:</strong> {token.name}
                </div>
                <div style={{ marginTop: '8px' }}>
                  <strong>Flare Contract:</strong><br />
                  <code style={{ fontSize: '0.75rem', color: '#A78BFA', wordBreak: 'break-all' }}>
                    {token.flare_contract}
                  </code>
                </div>
              </div>
            );
          })()}
        </div>
      )}
    </div>
  );
}
